module.exports = __webpack_public_path__ + "img/42-boy.9470858d.svg";